import { AppKitNetwork } from '@reown/appkit/networks';
import { createAppKit } from '@reown/appkit/react';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import type { Metadata } from '@reown/appkit-controllers';
import { safe } from '@wagmi/connectors';

import { getChain } from 'modules/api/utils/getChain';
import { IS_LOCAL, IS_STAGE } from 'modules/common/const';

function getDomainUrl() {
  if (IS_LOCAL) {
    return window.location.origin;
  }

  if (IS_STAGE) {
    return 'https://teststaking.matchain.io';
  }

  return 'https://matstake.io';
}

const DOMAIN_URL = getDomainUrl();
const PROJECT_ID = import.meta.env.VITE_REOWN_APP_ID;

const metadata: Metadata = {
  name: 'MAT Staking',
  description: 'Unified platform for staking MAT token.',
  url: DOMAIN_URL, // origin must match your domain & subdomain
  icons: ['https://matstake.io/favicon.svg'],
};

const networks: [AppKitNetwork, ...AppKitNetwork[]] = [
  getChain() as AppKitNetwork,
];

const isIframe = window?.self !== window?.top;

export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId: PROJECT_ID,
  connectors: isIframe ? [safe()] : undefined,
});

export const config = wagmiAdapter.wagmiConfig;

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId: PROJECT_ID,
  metadata,
  enableReconnect: false,
  features: {
    analytics: false,
    email: false,
    socials: false,
    onramp: false,
    swaps: false,
    legalCheckbox: false,
  },
  allWallets: 'HIDE',
  enableWalletGuide: false,
});
